import SegmentedProgressBar from './SegmentedProgressBar';
import SegmentedProgressBarLegend from './SegmentedProgressBarLegend/SegmentedProgressBarLegend';

export { SegmentedProgressBar, SegmentedProgressBarLegend };
export default SegmentedProgressBar;
